import React from 'react';
import PageHeader from '../components/PageHeader';
import Services from '../components/PageSections/services.js';
import Appointment from '../components/PageSections/appointment.js';

const OurServices = () => {
return (
	  <>
      <PageHeader name="Our Services" link="our-services" />

      {/* services section start */}
        <Services />
      {/* services section end */}


      {/* appointment section start */}
        <Appointment />
      {/* appointment section end */}
    </>
);
};

export default OurServices;
